// Color schemes for different data dimensions

export const REGION_COLORS = {
  NSW1: '#1890ff',
  QLD1: '#52c41a',
  VIC1: '#722ed1',
  SA1: '#fa8c16',
  TAS1: '#eb2f96'
};

// Base colors for fuel types with variants for differentiation
export const FUEL_TYPE_COLORS = {
  Coal: '#595959',
  Gas: '#faad14',
  Hydro: '#1890ff',
  Wind: '#52c41a',
  Solar: '#fadb14',
  Battery: '#722ed1',
  Biomass: '#8B4513',
  Geothermal: '#DC143C',
  Other: '#999999'
};

// Color variants for each fuel type (lighter/darker shades)
const FUEL_TYPE_VARIANTS = {
  Coal: ['#262626', '#434343', '#595959', '#8c8c8c', '#bfbfbf', '#d9d9d9'],
  Gas: ['#ad6800', '#d48806', '#faad14', '#ffc53d', '#ffd666', '#ffe58f'],
  Hydro: ['#0050b3', '#096dd9', '#1890ff', '#40a9ff', '#69c0ff', '#91d5ff'],
  Wind: ['#237804', '#389e0d', '#52c41a', '#73d13d', '#95de64', '#b7eb8f'],
  Solar: ['#ad8b00', '#d4b106', '#fadb14', '#ffec3d', '#fff566', '#fffb8f'],
  Battery: ['#391085', '#531dab', '#722ed1', '#9254de', '#b37feb', '#d3adf7'],
  Biomass: ['#5D2E0F', '#7A3D11', '#8B4513', '#A0522D', '#BC8F8F', '#D2B48C'],
  Geothermal: ['#8B0000', '#B22222', '#DC143C', '#F08080', '#FA8072', '#FFA07A'],
  Other: ['#595959', '#737373', '#999999', '#b3b3b3', '#cccccc', '#e6e6e6']
};

// Get color for entity based on fuel type with differentiation
export function getColorForEntity(entityName, fuelType, index) {
  const fuelTypeKey = fuelType || 'Other';
  const variants = FUEL_TYPE_VARIANTS[fuelTypeKey] || FUEL_TYPE_VARIANTS.Other;

  if (index !== undefined) {
    return variants[index % variants.length];
  }

  // Hash entity name for consistent variant selection
  let hash = 0;
  for (let i = 0; i < entityName.length; i++) {
    hash = entityName.charCodeAt(i) + ((hash << 5) - hash);
  }
  return variants[Math.abs(hash) % variants.length];
}

// Legacy function for backwards compatibility
export function getEntityColor(entityName, index) {
  const colors = [
    '#1890ff', '#52c41a', '#722ed1', '#fa8c16', '#eb2f96',
    '#13c2c2', '#faad14', '#f5222d', '#2f54eb', '#a0d911'
  ];

  if (index !== undefined) {
    return colors[index % colors.length];
  }

  let hash = 0;
  for (let i = 0; i < entityName.length; i++) {
    hash = entityName.charCodeAt(i) + ((hash << 5) - hash);
  }
  return colors[Math.abs(hash) % colors.length];
}
